import { makeStyles, shorthands } from "@fluentui/react-components";

export const useDetailModalStyles = makeStyles({
  header: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    columnGap: "1rem",
  },
  headerText: {
    display: "flex",
    flexDirection: "column",
    rowGap: "0.15rem",
  },
  title: {
    ...shorthands.margin(0),
    fontSize: "1.3rem",
    fontWeight: 700,
    color: "#201f1e",
  },
  subtitle: {
    ...shorthands.margin(0),
    fontSize: "0.9rem",
    color: "#605e5c",
  },
  headerRight: {
    display: "flex",
    alignItems: "center",
    columnGap: "0.5rem",
  },
  detailCard: {
    marginTop: "1.25rem",
    ...shorthands.border("1px", "solid", "#e1dfdd"),
    ...shorthands.borderRadius("8px"),
    ...shorthands.overflow("hidden"),
  },
  detailRow: {
    display: "flex",
    flexWrap: "wrap",
    columnGap: "1rem",
    ...shorthands.padding("0.85rem", "1rem"),
    ...shorthands.borderBottom("1px", "solid", "#f0f0f0"),
    "&:last-child": {
      ...shorthands.borderBottom("0"),
    },
  },
  detailLabel: {
    flexBasis: "40%",
    flexGrow: 1,
    minWidth: "8rem",
    wordBreak: "break-word",
    ...shorthands.margin(0),
    color: "#605e5c",
    fontSize: "0.9rem",
  },
  detailValue: {
    flexBasis: "50%",
    flexGrow: 1,
    minWidth: "8rem",
    wordBreak: "break-word",
    ...shorthands.margin(0),
    color: "#201f1e",
    fontSize: "0.9rem",
    fontWeight: 600,
  },
  approvalSection: {
    marginTop: "1.5rem",
  },
  approvalTitle: {
    ...shorthands.margin(0, 0, "0.75rem", 0),
    fontSize: "1.05rem",
    fontWeight: 700,
    color: "#201f1e",
  },
  buttonRow: {
    display: "flex",
    columnGap: "0.75rem",
    marginTop: "0.75rem",
  },
  approveButton: {
    flexGrow: 1,
    backgroundColor: "#107c10",
    ...shorthands.borderColor("#107c10"),
    ...shorthands.borderRadius("8px"),
    ":hover": {
      backgroundColor: "#0b5a0b",
      ...shorthands.borderColor("#0b5a0b"),
    },
  },
  declineButton: {
    flexGrow: 1,
    backgroundColor: "#a80000",
    ...shorthands.borderColor("#a80000"),
    ...shorthands.borderRadius("8px"),
    ":hover": {
      backgroundColor: "#800000",
      ...shorthands.borderColor("#800000"),
    },
  },
  statusPill: {
    display: "inline-block",
    ...shorthands.padding("0.2rem", "0.7rem"),
    ...shorthands.borderRadius("12px"),
    fontSize: "0.8rem",
    fontWeight: 600,
  },
  statusActive: {
    backgroundColor: "#dff6dd",
    color: "#107c10",
  },
  statusPending: {
    backgroundColor: "#fff4ce",
    color: "#8a6d00",
  },
  statusAccepted: {
    backgroundColor: "#deecf9",
    color: "#004e8c",
  },
  statusDeactivationRequested: {
    backgroundColor: "#fff4ce",
    color: "#8a6d00",
  },
  statusDeactivated: {
    backgroundColor: "#f3f2f1",
    color: "#605e5c",
  },
  statusRevoked: {
    backgroundColor: "#f3f2f1",
    color: "#605e5c",
  },
  statusDeclined: {
    backgroundColor: "#fde7e9",
    color: "#a80000",
  },
  statusExpired: {
    backgroundColor: "#f3f2f1",
    color: "#605e5c",
  },
});
